import { ToolName } from "@nova/constants"
import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux/rootReducer"
import { setActiveTool } from "../tool-registry"

export type MapCommentSort = "date" | "unread"

type UIState = {
    commentPlacingState:
        | { mode: "disabled" }
        | {
              mode: "placing"
          }
        | { mode: "writing"; lat: number; lng: number }
    hideAllComments: boolean
    listSort: MapCommentSort
}

const uiStateName = "map-comments-ui-v1"

const initialUIState: UIState = {
    commentPlacingState: { mode: "disabled" },
    hideAllComments: false,
    listSort: "date",
}

const {
    reducer: uiStateReducer,
    actions: { setCommentPlacingState, setHideAllComments, setListSort },
} = createSlice({
    name: uiStateName,
    initialState: { ...initialUIState },
    reducers: {
        setCommentPlacingState: (state, action) => {
            state.commentPlacingState = action.payload
        },
        setHideAllComments: (state, action: { payload: boolean }) => {
            state.hideAllComments = action.payload
        },
        setListSort: (state, action: { payload: MapCommentSort }) => {
            state.listSort = action.payload
        },
    },
    extraReducers: (b) =>
        b.addCase(setActiveTool, (state, action) => {
            if (action.payload === ToolName.Comment) {
                state.commentPlacingState = { mode: "placing" }
                state.hideAllComments = false
            } else {
                state.commentPlacingState = { mode: "disabled" }
            }
        }),
})

export { setCommentPlacingState, setHideAllComments, setListSort }

export const selectHideAllComments = (state: RootState) => state[uiStateName].hideAllComments

export const selectMapCommentListSort = (state: RootState) => state[uiStateName].listSort

export const uiReducer = { [uiStateName]: uiStateReducer }
